export default __webpack_public_path__ + "brochure.e78a9c2ece8512d6.svg";